import a52 from '../assets/rastreadores/a52.png';
import angellira from '../assets/rastreadores/angellira.png';
import autotrac from '../assets/rastreadores/autotrac.png';
import ravex from '../assets/rastreadores/ravex.png';
import sascar from '../assets/rastreadores/sascar.png';
import sighra from '../assets/rastreadores/sighra.png';

// Logos das tecnologias de rastreamento. Chave: nome normalizado (sem acento, espaço ou hífen).
const LOGOS = { a52, angellira, autotrac, ravex, sascar, sighra };

// Equipamentos do cadastro do GestaoFrotas (TecnologiaRastreador): a legenda mostra um selo de cada.
export const TECNOLOGIAS_COM_LOGO = ['Autotrac', 'Sighra', 'Sascar', 'A52', 'Ravex'];

export const chaveTecnologia = nome => String(nome || '')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .replace(/[^a-z0-9]/gi, '')
  .toLowerCase();

export const logoDaTecnologia = nome => LOGOS[chaveTecnologia(nome)] || null;
